class StockIndicator {
  constructor() {
    this.indicators = document.querySelectorAll('.product-stock-indicator');
    this.init();
  }

  init() {
    if (this.indicators.length === 0) return;
    
    this.indicators.forEach(indicator => {
      this.setupIndicator(indicator);
    });
    
    this.bindEvents();
  }

  setupIndicator(indicator) {
    const productId = indicator.dataset.productId;
    indicator.productId = productId;
    indicator.currentVariantId = indicator.dataset.variantId;
  }

  updateStockDisplay(indicator, variantId) {
    const productHandle = window.location.pathname.split('/products/')[1];
    
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        const variant = product.variants.find(v => v.id == variantId);
        
        if (variant) {
          const stockDot = indicator.querySelector('.stock-dot-indicator');
          const stockContainer = indicator.querySelector('.stock-indicator-display');
          
          if (variant.available) {
            stockDot.classList.remove('unavailable');
            stockDot.classList.add('available');
            stockContainer.classList.remove('out-of-stock');
            stockContainer.classList.add('in-stock');
          } else {
            stockDot.classList.remove('available');
            stockDot.classList.add('unavailable');
            stockContainer.classList.remove('in-stock');
            stockContainer.classList.add('out-of-stock');
          }
        }
      })
      .catch(error => console.error('Erreur stock:', error));
  }

  bindEvents() {
    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' || e.target.classList.contains('product-form__input')) {
        const newVariantId = e.target.value;
        
        this.indicators.forEach(indicator => {
          if (newVariantId !== indicator.currentVariantId) {
            indicator.currentVariantId = newVariantId;
            indicator.dataset.variantId = newVariantId;
            this.updateStockDisplay(indicator, newVariantId);
          }
        });
      }
    });
  }
}

// Initialiser quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  new StockIndicator();
});